import React from "react";
import "../assets/css/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <h3>ICA Global</h3>
        <p>Computer & Accounting Institute</p>
        <p>© 2026 All rights reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
